export default class OnboardingModel {
    constructor() {
        this._seenStepIds = new Set();
    }

    markOnboardingAsSeen(stepId) {
        this._seenStepIds.add(stepId);
    }

    hasSeenOnboarding(stepId) {
        return this._seenStepIds.has(stepId);
    }

    toObject() {
        return {
            seenStepIds: Array.from(this._seenStepIds)
        };
    }

    load(obj) {
        this._seenStepIds = new Set(obj.seenStepIds);
    }
}
